(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hc-vault-lock-modal"] && !Shopify.designMode) return;
  try {
    (function () {
  const dialog = document.getElementById('HCVaultDialog');
  if (!dialog) return;

  const openVaultMessage = function () {
    if (typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
  };

  document.addEventListener('click', function (event) {
    const link = event.target.closest('a[href]');
    if (!link) return;

    try {
      const destination = new URL(link.href, window.location.origin);
      if (destination.pathname.replace(/\/$/, '') !== '/pages/vault') return;
      event.preventDefault();
      openVaultMessage();
    } catch (error) {
      return;
    }
  });

  dialog.querySelectorAll('[data-hc-vault-close]').forEach(function (button) {
    button.addEventListener('click', function () { dialog.close(); });
  });

  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) dialog.close();
  });

  if (window.location.pathname.replace(/\/$/, '') === '/pages/vault') {
    window.requestAnimationFrame(openVaultMessage);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
